// extracted by mini-css-extract-plugin
export default {"plot":"ChartSkeleton-module__plot","legend":"ChartSkeleton-module__legend","pill":"ChartSkeleton-module__pill"};